import { Box } from '@mui/material';
import { IntegrationSettingsEntry, IntegrationSettingsAccountLevelForm } from 'modules/integrationSettings/types';
import { IntegrationSettingsTable } from './IntegrationSettingsTable';
import { SyndicatedAccountSettings } from './SyndicatedAccountSettings';

interface AccountTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsAccountLevelForm[];
  vendorProfile?: { allowSyndication?: boolean };
}

export const AccountTab = ({ integrationSettings, tableData, vendorProfile }: AccountTabProps) => {
  const allowSyndication = !!vendorProfile?.allowSyndication;

  return (
    <Box mt={2}>
      {allowSyndication ? (
        <SyndicatedAccountSettings integrationSettings={integrationSettings} tableData={tableData} />
      ) : (
        <IntegrationSettingsTable integrationSettings={integrationSettings} tableData={tableData} />
      )}
    </Box>
  );
};
